(function () {
    
    const currentUrl  = window.location.href;
    const newsEventsBox = document.getElementById('news-events-box');
    if(currentUrl.includes('aboutus')) {
        if(newsEventsBox){
            newsEventsBox.classList.add('bg-white');
            newsEventsBox.classList.remove('bg-gray-100');
        }
    } else{
        if(newsEventsBox) {
            newsEventsBox.classList.add('bg-gray-100');
            newsEventsBox.classList.remove('bg-white');
        }
    }
})()